import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Poetry from '../views/Poetry.vue'
import Detail from '../views/Detail.vue'
import MiniPoetryApp from '../views/MiniPoetryApp.vue'
import Search from '../views/Search.vue'
import Dingdanxia from '../views/ddx/Dingdanxia.vue'
import JD from '../views/ddx/JD.vue'
import DdxIndex from '../views/ddx/Index.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/detail/:packageName',
    name: 'Detail',
    component: Detail
  },
  {
    path: '/minipoetryapp',
    name: 'minipoetryapp',
    component: MiniPoetryApp
  },
  {
    path: '/search/:keyword',
    name: 'Search',
    component: Search,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/poetry/:id',
    name: 'Poetry',
    component: Poetry
  },
  {
    path: '/ddx/:platform',
    name: 'Dingdanxia',
    component: Dingdanxia
  },
  {
    path: '/ddxindex',
    name: 'DdxIndex',
    component: DdxIndex
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
